module.exports = __webpack_public_path__ + "static/Tobiasz_1_min-250a13f575f2639b3006c897cf472243.jpg";